import { createContext, useState, useContext,useEffect } from "react";
import { getDeck } from "../service/main/api";
import { useLoading } from "./LoadingContext";
import { updateSlots } from "../service/main/api";
import { useUserContext } from "./UserContext";


const DeckContext = createContext();

export const useDeck = () => useContext(DeckContext);

export const DeckProvider = ({ children }) => {
 const {user} = useUserContext();
  const {setIsLoading} = useLoading();
  const [userCards, setUserCards] = useState([]);
  const [defaultDeck, setDefaultDeck] = useState([]);
  const [deck, setDeck] = useState(null);
  const [slots, setSlots] = useState([]);

    const fetchDeck = async () => {
        try {
        setIsLoading(true);
        const res = await getDeck();
        if(res?.success){
            const {deck,cards} = res.data;
            setDefaultDeck(deck);
           const  {normalizedDeck,normalizedUserCards} = normalizeData(deck,cards);
            setDeck(normalizedDeck);
            setSlots(normalizedDeck.slots);
            setUserCards(normalizedUserCards);
            setIsLoading(false);
        }else{
            setIsLoading(false);
            alert(res.message);
        }
    } catch (error) {
        setIsLoading(false);
         alert("Failed to fetch deck:", error
        );
    }
    }

    const normalizeData = (deck,userCards) => {
        try {
            const {slots} = deck;
            let normalizedSlots = [];
            let normalizedUserCards = [];
            slots.map((slot) => {
                const userCard = userCards.find((card) => card._id === slot._id);
                if(!userCard){
                    clearSlots();
                    return;
                }
                if(!userCard){
                    normalizedSlots.push(null);
                    console.log("Card not found");
                    return;
                }
                let cardData = {
                    _id: userCard._id,
                    name: userCard.card.name,
                    rarity: userCard.card.rarity,
                    level: userCard.level,
                    type: userCard.card.cryptidType,
                    weakness: userCard.card.weaknessType,
                    miningPower: userCard.miningPower,
                    cardId: userCard.card.cardId || null,
                    imageUri: userCard.card.imageUri,
                }

                normalizedSlots.push(cardData);
            });
            userCards.map((card) => {
                let cardData = {
                    _id: card._id,
                    name: card.card.name,
                    rarity: card.card.rarity,
                    level: card.level,
                    type: card.card.cryptidType,
                    weakness: card.card.weaknessType,
                    miningPower: card.miningPower,
                    cardId: card.card.cardId || null,
                    imageUri: card.card.imageUri,
                }
                normalizedUserCards.push(cardData);
            });
           return {normalizedDeck:{...deck,slots:normalizedSlots},normalizedUserCards:normalizedUserCards};
        } catch (error) {
            console.error("Failed to normalize data:", error);
            return {normalizedDeck:deck,normalizedUserCards:userCards};
        }

    };
    useEffect(() => {
        if(user){
        fetchDeck();
        }
    }, [user])

    const refreshDeck = async () => {
        fetchDeck();
    };
    const updateUserSlots = async (slots) => {
        try {
            setIsLoading(true);
        const res = await updateSlots({slots});
        if(res?.success){
            const response = await getDeck();
            if(response?.success){
                const {deck, cards} = response.data;
                const {normalizedDeck, normalizedUserCards} = normalizeData(deck, cards);
                setDeck(normalizedDeck);
                setUserCards(normalizedUserCards);
                setSlots(normalizedDeck.slots);
                setIsLoading(false);
                return;
            }
            const {deck, cards} = res.data;
            const {normalizedDeck, normalizedUserCards} = normalizeData(deck, cards);
            setDeck(normalizedDeck);
            setUserCards(normalizedUserCards);
            setSlots(normalizedDeck.slots);
            setIsLoading(false);
        }else{
            setIsLoading(false);
            alert("Failed to update slots:", res?.message);
        }
        } catch (error) {
            setIsLoading(false);
        console.error("Failed to update user slots:", error);
        }
    };
    const clearSlots = async () => {
        try {
        setIsLoading(true);
        const res = await updateSlots({slots:[]});
        if(res?.success){
            const {deck, cards} = res.data;
            const {normalizedDeck, normalizedUserCards} = normalizeData(deck, cards);
            setDeck(normalizedDeck);
            setSlots(normalizedDeck.slots);
            setUserCards(normalizedUserCards);
            setIsLoading(false);
        }else{
            setIsLoading(false);
            alert("Failed to clear slots:", res?.message);
        }

        }
        catch (error) {
            setIsLoading(false);
        console.error("Failed to clear slots:", error);
        }
    };
  return (
    <DeckContext.Provider value={{ deck, setDeck, slots, userCards, setUserCards ,refreshDeck,updateUserSlots,clearSlots}}>
      {children}
    </DeckContext.Provider>
  );
};
